module.exports = __webpack_public_path__ + "assets/img/map-rakumart.cefe0942.svg";